import api from '../../common/lib/api';
import { IS_IN_DEV_MODE } from '../../constants';

export default function updateLinkFor(load, handleError) {
  return async (system, companyId, billAccountingCompanyId, saleAccountingCompanyId, billedSeparately) => {
    try {
      await api.post('/companies-link', { system, companyId, billAccountingCompanyId, saleAccountingCompanyId, billedSeparately });
      if (!IS_IN_DEV_MODE) {
        load();
      }
    }
    catch (e) {
      handleError(e);
    }
  };
}
